module.exports = __webpack_public_path__ + "img/6.6dce7597.jpg";